export const SET_TRIBES = 'tribeFinder/SET_TRIBES';
export const SET_LOADING = 'tribeFinder/SET_LOADING';
export const SET_GENERATING = 'tribeFinder/SET_GENERATING';
export const SET_REGEN_POST_KEY = 'tribeFinder/SET_REGEN_POST_KEY';
export const UPDATE_TRIBE_POST = 'tribeFinder/UPDATE_TRIBE_POST';
export const SET_BRIEF = 'tribeFinder/SET_BRIEF';
export const SET_FILTER = 'tribeFinder/SET_FILTER';
export const SET_ERROR = 'tribeFinder/SET_ERROR';
